import {Route, Routes} from "react-router-dom";
import {RecoilRoot} from "recoil";
import NotAuthorizedDialog from "../authentication/component/NotAuthorizedDialog";
import {RecoveryScope} from "./types";
import {useHasScope} from "../../config/globalConfig";
import {InsertBookingPage, RequestSubstitutionPage} from "../booking/pages";
import RaVehicleIdentification from "../network/check-out-in/ra-vehicle-identification/ra-vehicle-identification";
import { EventInfo } from "../booking/pages/request-substitution/sections";

const RecoveryMain = () => {
    const hasScope = useHasScope;

    if (!hasScope( RecoveryScope.Recovery)) {
        return ( <NotAuthorizedDialog />);
    }

    return (
        <Routes>
            <Route
                path="/insert-booking" element={
                    hasScope(RecoveryScope.BookingInsertRecovery) ?
                        <RecoilRoot key='insert-booking'>
                            <InsertBookingPage />
                        </RecoilRoot> :
                        <NotAuthorizedDialog />
                    }
            />
            <Route
                path="/ra-vehicle-identification/:type" element={
                (hasScope(RecoveryScope.RaInsertCheckInRecovery) || hasScope(RecoveryScope.RaInsertCheckOutRecovery)) ?
                    <RecoilRoot key={'ra-vehicle-identification'}>
                        <RaVehicleIdentification recoveryMode={true}/>
                    </RecoilRoot> :
                    <NotAuthorizedDialog />
                }
            />
        </Routes>

    );
};

export default RecoveryMain;
